import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

// Automatically attach token to EVERY request
api.interceptors.request.use((config) => {
  if (String(config.method || "get").toLowerCase() === "get") {
    config.headers = config.headers || {};
    config.headers["Cache-Control"] = "no-cache";
    config.headers.Pragma = "no-cache";
    config.headers.Expires = "0";
    config.params = {
      ...(config.params || {}),
      _ts: Date.now(),
    };
  }

  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
